export default function ErrorPage(){
    return (
        <div style={{width:'100%',height:'100%',display:'flex',alignItems:'center',justifyContent:'center'}}>
            <img src="/404.png"/>
        </div>
    )
}
